export default "__VITE_ASSET___hJo9BWg__"